import { Injectable } from '@angular/core';


interface MenuItem {
  name:string,
  link?:string,
  icon?:string,
  id:string
  children?:MenuItem[]
}


@Injectable({
  providedIn: 'root'
})
export class MenuService {


  private profiles:{[key:string]:MenuItem[]}={
    ADMIN:[
      {name: 'Partenaires',link:'/partners',icon:'fa fa-handshake-o',id:'partners'},
      {name: 'Utilisateurs',link:'/users',icon:'fa fa-users',id:'users'},
      {name: 'Commissions',link:'/commissions',icon:'fa fa-share-alt',id:'commissions'},
      {name: 'Rapports',link:'/rapports',id:'rapports',icon:'fa fa-table',
        children:[
          {name :'Journal transactions',link:'/transactions' ,id:'transactions',icon:'fa fa-list'},
          {name :'Details compense',link:'/detail-compense',id:'detail-compense',icon:'fa fa-list'},
          {name :'Releve de compte', link:'/account', id:'account',icon:'fa fa-book'},
          {name :'Impression reçu',link:'/duplicata', id:'duplicata',icon:'fa fa-print'}
        ]
      },
      {name: 'Remboursement',link:'/cashout', id:'cashout',icon:'fa fa-money'},
      {name: 'Notifications',link:'/notification', id:'notification',icon:'fa fa-envelope'},  
    ],
    SYS_ACCOUNTANT:[
      {name: 'Partenaires',link:'/partners',id:'partners',icon:'fa fa-handshake-o'},
      {name: 'Utilisateurs',link:'/users',id:'users',icon:'fa fa-users'},
      {name: 'Commissions',link:'/commissions',id:'commissions',icon:'fa fa-share-alt'},
      {name: 'Rapports',link:'/rapports',id:'rapports',icon:'fa fa-table',
        children:[
          {name :'Journal transactions',link:'/transactions' ,id:'transactions',icon:'fa fa-list'},
          {name :'Releve de compte',link:'/account',id:'account',icon:'fa fa-book'},
          {name :'Impression reçu',link:'/duplicata',id:'duplicata',icon:'fa fa-print'}
        ]
      },
      {name: 'Remboursement',link:'/cashout',id:'cashout',icon:'fa fa-money'}, 
    ],
     SCHOOLS_MANAGER:[
      {name: 'Partenaires',link:'/partners',id:'partners',icon:'fa fa-handshake-o'},
      {name: 'Utilisateurs',link:'/users',id:'users',icon:'fa fa-users'},
      {name: 'Commissions',link:'/commissions',id:'commissions',icon:'fa fa-share-alt'},
      {name: 'Rapports',link:'/rapports',id:'rapports',icon:'fa fa-table',
        children:[
          {name :'Journal transactions',link:'/transactions' ,id:'transactions',icon:'fa fa-list'},
          {name :'Releve de compte',link:'/account',id:'account',icon:'fa fa-book'},
          {name :'Impression reçu',link:'/duplicata',id:'duplicata',icon:'fa fa-print'}
        ]
      },
      {name: 'Remboursement',link:'/cashout',id:'cashout',icon:'fa fa-money'},
       {name: 'Notifications',link:'/notification', id:'notification',icon:'fa fa-envelope'} 
    ],
    ADMIN_MERCH:[
      {name: 'Rapports',link:'/transactions',id:'transactions',icon:'fa fa-table',
        children:[
          {name :'Journal transactions',link:'/transactions',id:'journaltrx',icon:'fa fa-list'},
          {name :'Releve de compte',link:'/account',id:'account',icon:'fa fa-book'},
          {name :'Impression reçu',link:'/duplicata',id:'duplicata',icon:'fa fa-print'}
        ]
      } ,
      {name: 'Appel de fonds',link:'/cashout', id:'cashout',icon:'fa fa-money'},
      {name: 'QrCode',link:'/qrcode/generate', id:'qrcode',icon:'fa fa-qrcode'},
      {name: 'Envoi paiement',link:'/push-payment', id:'push-payment',icon:'fa fa-paper-plane'},
    ],
    ADMIN_SCHOOL:[
      {name: 'Rapports',link:'/transactions',id:'transactions',icon:'fa fa-table',
        children:[
          {name :'Journal transactions',link:'/transactions', id:'journaltrx',icon:'fa fa-list'},
          {name :'Releve de compte',link:'/account', id:'account',icon:'fa fa-book'},
          {name :'Impression reçu',link:'/duplicata', id:'duplicata',icon:'fa fa-print'}
        ]
      } ,
      {name: 'Chargement',link:'/school/bill/bill', id:'loadBill',icon:'fa fa-upload',},
      {name:'Paiement', link:'/cashier/school/payment',id:'cashierPaay',icon:'fa fa-money',
        children: [
      {name:'Mensualité', link:'/cashier/school/payment',id:'cashierPaay2',icon:'fa-regular fa-calendar'},
      {name:"Inscription",link:"/cashier/school/payment/subscription", id:'payyInscripttion',icon:'fa fa-graduation-cap'},
      {name:"Anticipé",link:"/cashier/school/payment/anticipation", id:'cashiPayAnticipation',icon:'fa fa-money'},
      ]},  
      {name: 'Appel de fonds',link:'/cashout', id:'cashout',icon:'fa fa-money'},
      {name: 'QrCode',link:'/qrcode/generate', id:'generateQrcode',icon:'fa fa-qrcode'},
      {name: 'Envoi paiement',link:'/push-payment', id:'push-payment',icon:'fa fa-paper-plane'},
      
      {name:'Inscription', link:'/school/subscription/level',id:'inscriptionLevel',icon:'fa fa-graduation-cap',
        children: [
          {name:"Frais inscription",link:"/school/subscription/level", id:'fraisInscription',icon:'fa fa-graduation-cap'},
          {name:"Frais transport",link:"/school/subscription/transport", id:'fraisTransport',icon:'fa fa-bus'},
          {name:"Chargement reliquat",link:"/school/bill/reliquat",id:'chargementReliquat',icon:'fa fa-upload'},

      ]}
         
    ],
    MERCHANT_CHECKER:[
      {name: 'Rapports',link:'/transactions',id:'transactions',icon:'fa fa-table',
        children:[
          {name :'Journal transactions',link:'/transactions', id:'journaltrx' ,icon:'fa fa-list'},
          {name :'Releve de compte',link:'/account', id:'account',icon:'fa fa-book'},
          {name :'Impression reçu',link:'/duplicata', id:'duplicata',icon:'fa fa-print'}
        ]
      } ,
      {name: 'Appel de fonds',link:'/cashout', id:'cashout',icon:'fa  fa-money'},
      {name: 'QrCode',link:'/qrcode/generate', id:'generateQrcode',icon:'fa fa-qrcode'},
         
    ],
    ADMIN_HOUSING_PROMOTER:[
      {
        name:'Gestion', link:'/housing',id:'housing',icon:'fa fa-home',
        children:[
          {name :'Produits',link:'/housing/products',id:'housing-products',icon: 'fa fa-home'},
          {name: 'Souscriptions',link:'/housing/subscriptions',id:'housing-subscriptions',icon:'fa fa-group'}
        ]
      },
      {  name: 'Rapports',link:'/transactions',id:'transactions',icon:'fa fa-table',
        children:[
          {name :'Journal transactions',link:'/transactions', id:'journaltrx' ,icon:'fa fa-list'},
          {name :'Releve de compte',link:'/account', id:'account',icon:'fa fa-book'},
          {name :'Impression reçu',link:'/duplicata', id:'duplicata',icon:'fa fa-print'}
        ]
      } ,
      {name: 'Appel de fonds',link:'/cashout', id:'cashout',icon:'fa  fa-money'},
      {name: 'QrCode',link:'/qrcode/generate', id:'generateQrcode',icon:'fa fa-qrcode'},
         
    ]
  }
  

  constructor() { }

  getMenu(profile:string):MenuItem[]{

    return this.profiles[profile]||[];
  }
}
